/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styles from './not-found.module.scss';

const NotFound = () => (
  <div className={styles.wrapper}>
    <div className={styles.logoWrapper}>
      <span>
      <img src={`${process.env.ASSETS_URL}/images/logo.svg`} width="300px" height="68px" className={styles.logo} />
      </span>
    </div>

    <div className={styles.box}>
      <div className={styles.content}>
        <p>SOMETHING</p>
        <p>WENT WRONG</p>
      </div>
    </div>

    <img src={`${process.env.ASSETS_URL}/images/404.png`} width="606px" height="338px" className={styles.error} />
  </div>
);

export default NotFound;
